import {Inject, Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {EMPTY, Observable} from 'rxjs';
import {LOGIN_TOKEN} from "../tokens/tokens";
import {AuthService} from "../service/auth.service";
import {Router} from "@angular/router";

@Injectable()
export class LoginTokenInterceptor implements HttpInterceptor {

  constructor(@Inject(LOGIN_TOKEN) private loginToken: string,
              private authService: AuthService,
              private router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = sessionStorage.getItem(this.loginToken);
    let modifiedRequest;
    if (token && this.authService.isTokenExpired()) {
      this.authService.clearToken();
      this.router.navigate(['/login']);
      return EMPTY;
    }
    if (token) {
      modifiedRequest = request.clone({
        setHeaders: {
          'Authorization': `Bearer ${token}`,
        },
      });
    }
    if (modifiedRequest)
      return next.handle(modifiedRequest);
    else
      return next.handle(request);

  }
}
